import React, { useState } from 'react'

import ExclamationMarkIcon from 'components/Common/SvgIcons/ExclamationMarkIcon'
import PopOver from 'components/Common/Popover'

/** An icon that displays helpful information about what Plays are in a Tooltip when clicked. */
const PlaysDefinitionTooltip = () => {
  const [showToolTip, setShowToolTip] = useState(false)
  const [isPopoverOpen, setIsPopoverOpen]: any = useState(false)
  return (
    <span className="inline-block cursor-pointer" onClick={() => setShowToolTip(!showToolTip)}>
      <span>
        <span onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
          <ExclamationMarkIcon className="fill-primary hover:fill-primary-brand relative h-[20px] w-[20px]" />
        </span>
        <span>
          <PopOver
            isOpen={isPopoverOpen}
            reposition={true}
            align="center"
            positions={['bottom']}
            content={
              <div className="flex flex-col items-center pt-3">
                <div className="font-primary font-normal text-black xs:w-[340px] sm:w-[450px] bg-[#D5E0FA] rounded-[7px] px-5 pt-5 pb-3 shadow-2xl leading-6">
                  <h5 className="pb-3 text-lg font-bold">What are Plays?</h5>
                  <p className="text-base pb-3">
                    Plays are part of how GoTackle helps you reach your business goals.
                  </p>
                  <p className="text-base">
                    Running GoTackle plays will help you go step-by-step through business processes,
                    setting up tech tools, and learning how to use tech tools in running your
                    business.
                  </p>
                </div>
              </div>
            }
          />
        </span>
      </span>
    </span>
  )
}

export default PlaysDefinitionTooltip
